import React, { useState, useRef } from "react";
import axios from "axios";
import "../styles/SinavModal.css";

// Kart ID -> Soru seti
const SORU_BANKASI = {
  // Kart 1: (senin mevcut sabit soruların)
  1: [
    {
      soru: "1. İş sağlığı ve güvenliğinin temel amacı aşağıdakilerden hangisidir?",
      secenekler: [
        "Ev kazalarını önlemek",
        "Üretimi artırmak",
        "İş kazaları ve meslek hastalıklarını önlemek",
        "İş gücünü denetlemek",
      ],
      dogruCevap: "İş kazaları ve meslek hastalıklarını önlemek",
    },
    {
      soru: "2. 6331 Sayılı İş Sağlığı ve Güvenliği Kanunu hangi çalışanları kapsar?",
      secenekler: [
        "Sadece kamu çalışanlarını",
        "Sadece özel sektör çalışanlarını",
        "Ev hizmetinde çalışanları",
        "Kamu ve özel sektör çalışanlarını",
      ],
      dogruCevap: "Kamu ve özel sektör çalışanlarını",
    },
    {
      soru: "3. İş kazası tanımına göre, aşağıdakilerden hangisi iş kazası sayılmaz?",
      secenekler: [
        "İşyerinde ayağının kayıp düşmesi",
        "Servis aracında trafik kazası geçirmesi",
        "Tatilde kayak yaparken düşmesi",
        "Görev sırasında elektrik çarpması",
      ],
      dogruCevap: "Tatilde kayak yaparken düşmesi",
    },
    {
      soru: "4. Aşağıdakilerden hangisi acil durumlara örnek değildir?",
      secenekler: ["Yangın", "Deprem", "Servis arızası", "Patlama"],
      dogruCevap: "Servis arızası",
    },
    {
      soru: "5. Tehlike nedir?",
      secenekler: [
        "İş yerinde çalışan sayısı",
        "Riskin azalması",
        "Zarar verme potansiyeli olan durum",
        "İş gücü verimliliği",
      ],
      dogruCevap: "Zarar verme potansiyeli olan durum",
    },
  ],

  // Kart 2: İSG Sağlık Konuları (dosyadaki sorular)
  2: [
    {
      soru: "1. Aşağıdakilerden hangisi meslek hastalığına örnektir?",
      secenekler: ["Grip", "Silikozis", "Mide üşütmesi", "Boğaz enfeksiyonu"],
      dogruCevap: "Silikozis",
    },
    {
      soru:
        "2. Aşağıdakilerden hangisi kimyasal risk etmenlerinden korunmak için alınması gereken önlemlerden biridir?",
      secenekler: [
        "Gürültü ölçümü yapmak",
        "Eldiven, maske ve gözlük kullanmak",
        "Çalışanlara mola saatlerini artırmak",
        "Psikolojik destek sağlamak",
      ],
      dogruCevap: "Eldiven, maske ve gözlük kullanmak",
    },
    {
      soru:
        "3. Aşağıdakilerden hangisi iş kazası sonrası yapılması gereken ilk adımlardan biridir?",
      secenekler: [
        "Olayı gizlemek",
        "Yaralıya ilk yardım uygulamak ve gerekli bildirimleri yapmak",
        "Mesaiye devam etmek",
        "Sadece şikayet olursa doktora göndermek",
      ],
      dogruCevap:
        "Yaralıya ilk yardım uygulamak ve gerekli bildirimleri yapmak",
    },
    {
      soru:
        "4. Tozlu ortamlarda çalışmanın en çok etkilediği organ aşağıdakilerden hangisidir?",
      secenekler: ["Karaciğer", "Akciğer", "Böbrek", "Kalp"],
      dogruCevap: "Akciğer",
    },
    {
      soru:
        "5. İşyerinde biyolojik risk etmenlerine maruz kalmayı azaltmanın en etkili yolu aşağıdakilerden hangisidir?",
      secenekler: [
        "El hijyeni ve kişisel koruyucu ekipman kullanımı",
        "Gürültü ölçümü yapmak",
        "Ofis mobilyalarını değiştirmek",
        "Fazla mesaiyi azaltmak",
      ],
      dogruCevap: "El hijyeni ve kişisel koruyucu ekipman kullanımı",
    },
  ],
  3: [
    {
      soru: "1. Yangın söndürmede 'soğutma' etkisini en iyi hangi söndürme maddesi sağlar?",
      secenekler: ["Kuru kimyevi toz", "Karbondioksit (CO₂)", "Su", "Köpük"],
      dogruCevap: "Su",
    },
    {
      soru: "2. Elektrik çarpmasında vücuttan geçen akımın en tehlikeli etkisi aşağıdakilerden hangisidir?",
      secenekler: ["Deri yanıkları", "Kas spazmı", "Kalp fibrilasyonu", "Nefes darlığı"],
      dogruCevap: "Kalp fibrilasyonu",
    },
    {
      soru: "3. Toz patlamalarının oluşabilmesi için aşağıdakilerden hangisi gerekli değildir?",
      secenekler: [
        "Oksijen",
        "Ateşleme kaynağı",
        "Tozun patlayabilir özellikte olması",
        "Tozun nemli olması",
      ],
      dogruCevap: "Tozun nemli olması",
    },
    {
      soru: "4. Gürültü maruziyetinde 'günlük sekiz saatlik maruziyet sınır değeri' kaç dB(A) olarak belirlenmiştir?",
      secenekler: ["80 dB(A)", "85 dB(A)", "87 dB(A)", "90 dB(A)"],
      dogruCevap: "87 dB(A)",
    },
    {
      soru: "5. Aşağıdaki yangın sınıflarından hangisi 'gaz yangınları' için doğrudur?",
      secenekler: ["A sınıfı", "B sınıfı", "C sınıfı", "D sınıfı"],
      dogruCevap: "C sınıfı",
    },
  ],
  4: [
    {
      soru: "1. İSG eğitimlerinin temel amacı nedir?",
      secenekler: [
        "Satışları artırmak",
        "Çalışanların güvenlik ve sağlık farkındalığını geliştirmek",
        "Yeni ürün tanıtmak",
        "Vardiya düzenini değiştirmek"
      ],
      dogruCevap: "Çalışanların güvenlik ve sağlık farkındalığını geliştirmek"
    },
    {
      soru: "2. “Bizim güvenliğimiz ve sağlığımız sevdiklerimizin mutluluğudur” mesajı neyi vurgular?",
      secenekler: [
        "Müşteri memnuniyetini",
        "İndirim kampanyalarını",
        "Çalışan güvenliğinin aileye etkisini",
        "Satış hedeflerini"
      ],
      dogruCevap: "Çalışan güvenliğinin aileye etkisini"
    },
    {
      soru: "3. Eğitimlerin yıl sonuna kadar tamamlanması neden önemlidir?",
      secenekler: [
        "Sertifikalar zorunlu olduğu için",
        "Mağaza kapanacağı için",
        "Kampanya başlayacağı için",
        "Yeni personeller geleceği için"
      ],
      dogruCevap: "Sertifikalar zorunlu olduğu için"
    },
    {
      soru: "4. Mağaza içinde en sık karşılaşılan risklerden biri hangisidir?",
      secenekler: [
        "Yanlış ürün etiketleme",
        "Islak zemin ve kayma riski",
        "Müşteri memnuniyeti",
        "Raf düzeni"
      ],
      dogruCevap: "Islak zemin ve kayma riski"
    },
    {
      soru: "5. İSG eğitiminde anlatılan bilgiler neden 'dokunan bilgiler' olarak tanımlanır?",
      secenekler: [
        "Günlük iş akışımızı doğrudan etkilediği için",
        "Sadece teorik olduğu için",
        "Sadece yöneticilere yönelik olduğu için",
        "İzlenmesi zor olduğu için"
      ],
      dogruCevap: "Günlük iş akışımızı doğrudan etkilediği için"
    }
  ],


};

export default function SinavModal({
  onKapat,
  onBitir,
  aktifModul,
  kartId = 1, // 1: İSG Genel Konular, 2: İSG Sağlık Konuları
}) {
  const sorular = SORU_BANKASI[kartId] || [];
  const [cevaplar, setCevaplar] = useState(Array(sorular.length).fill(""));
  const [sinavBitti, setSinavBitti] = useState(false);
  const [dogruSayisi, setDogruSayisi] = useState(0);
  const [shakeIndex, setShakeIndex] = useState(null);
  const [gosterEksikUyari, setGosterEksikUyari] = useState(false);

  const soruRefs = useRef([]);

  const handleSecim = (index, secim) => {
    const yeni = [...cevaplar];
    yeni[index] = secim;
    setCevaplar(yeni);
  };

  const sinaviBitir = async () => {
    setGosterEksikUyari(true);
    const bosIndex = cevaplar.findIndex((c) => c === "");
    if (bosIndex !== -1) {
      setShakeIndex(bosIndex);
      soruRefs.current[bosIndex]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setTimeout(() => setShakeIndex(null), 500);
      return;
    }

    try {
      const token = localStorage.getItem("token");

      // a,b,c,d formatına çevir
      const cevapObjesi = {};
      cevaplar.forEach((cevap, i) => {
        if (cevap !== "") {
          const harf = String.fromCharCode(97 + parseInt(cevap, 10)); // 0->a,1->b...
          cevapObjesi[`cevap${i + 1}`] = harf;
        }
      });

      const payload = { modul: aktifModul, ...cevapObjesi };

      const res = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/Isg/bitir`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const basarili = res.data.basari === true;
      const message = res.data.message || "";
      const dogruMatch = message.match(/Doğru: (\d+)/);
      const dogru = dogruMatch ? parseInt(dogruMatch[1], 10) : 0;

      setDogruSayisi(dogru);
      setSinavBitti(true);

      const autoCloseDelay = aktifModul === 4 ? 7000 : 3000; 

      setTimeout(() => {
        onBitir(basarili);
        onKapat();
      }, autoCloseDelay);

    } catch (error) {
      console.error("Sınav bitirme hatası:", error);
      alert("Sınav gönderiminde hata oluştu, lütfen tekrar deneyin.");
    }
  };
  return (
    <div className="sinav-overlay">
      <div className="sinav-icerik">
        <button className="sinav-kapat" onClick={onKapat}>
          ✖
        </button>
        <h2>📋 Eğitim Sınavı</h2>

        {!sinavBitti ? (
          <>
            {sorular.map((soru, i) => (
              <div
                key={i}
                className={`soru-blok ${gosterEksikUyari && cevaplar[i] === "" ? "eksik-soru" : ""
                  } ${shakeIndex === i ? "shake" : ""}`}
                ref={(el) => (soruRefs.current[i] = el)}
              >
                <p>
                  <strong>{soru.soru}</strong>
                </p>
                {soru.secenekler.map((secenek, j) => (
                  <label key={j} className="secenek">
                    <input
                      type="radio"
                      name={`soru-${i}`}
                      value={j}
                      checked={cevaplar[i] === j.toString()}
                      onChange={() => handleSecim(i, j.toString())}
                    />
                    <strong>{String.fromCharCode(65 + j)})</strong> {secenek}
                  </label>
                ))}
              </div>
            ))}

            <button className="sinavi-bitir-btn" onClick={sinaviBitir}>
              ✅ Sınavı Bitir
            </button>
          </>
        ) : (
          <div className="sonuc-mesaj">
            {dogruSayisi >= 3 ? (
              <>
                <p>🎉 Tebrikler, {dogruSayisi} doğru ile geçtiniz!</p>

                {aktifModul === 4 && (
                  <p className="modul4-tebrik">
                    “İSG 4. Modülünü başarıyla tamamlayarak 2 saatlik İş Sağlığı ve Güvenliği
                    eğitim sertifikasına hak kazandınız. Tebrik ederiz.”
                  </p>
                )}
              </>
            ) : (
              <p>
                ❌ Yetersiz doğru: {dogruSayisi}/{sorular.length}. Tekrar
                deneyin.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
